export enum RoleEnum {
  InternalTeam = 1,
  Member = 2,
  Admin = 3,
  EnrollmentCommittee = 4,
  LoanCommittee = 5,
  HRHOD = 6,
}
